import { Component, Input, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'filter-select-check-all',
  templateUrl: './filterSelectAll.component.html'
})
export class FilterSelectAllComponent implements OnInit {
  @Input() model: NgModel;
  @Input() values = [];
  @Input() text = 'Select All';

  constructor() { }

  ngOnInit() {
  }

  isChecked(): boolean {
    if (this.model && this.values) {
    return this.model.value && this.values.length
      && this.model.value.length === this.values.length;
    }
  }

  isIndeterminate(): boolean {
    if (this.model && this.values) {
    return this.model.value && this.values.length && this.model.value.length
      && this.model.value.length < this.values.length;
    }
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      this.model.update.emit(this.values);
    } else {
      this.model.update.emit([]);
    }
  }
}
